if (!customElements.get('newsletter-popup')) {
  customElements.define(
    'newsletter-popup',
    class NewsletterPopup extends HTMLElement {
      constructor() {
        super();
        this.closeButton = this.querySelector('.newsletter-popup__close');
        this.overlay = this.querySelector('.newsletter-popup__overlay');

        this.closeButton?.addEventListener('click', (e) => {
          e.preventDefault();
          this.hide();
        });
        this.addEventListener('click', (event) => {
          if (!event.target.closest('.newsletter-popup__dialog')) this.hide();
        });
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        this.dataset.section = this.closest('.shopify-section')?.id?.replace('shopify-section-', '') || '';
        document.body.appendChild(this);

        if (this.dataset.enabled !== 'true') return;

        // In theme editor, show immediately for preview
        if (Shopify.designMode) {
          this.show();
          this.bindEditorEvents();
          return;
        }

        // Already subscribed — never show again
        if (localStorage.getItem('newsletter-popup-subscribed') === 'true') return;

        // Check frequency
        const dismissed = localStorage.getItem('newsletter-popup-dismissed');
        if (dismissed) {
          const frequency = parseInt(this.dataset.frequency, 10) || 7;
          const daysSince = (Date.now() - parseInt(dismissed, 10)) / 86400000;
          if (daysSince < frequency) return;
        }

        // Check mobile
        if (this.dataset.showMobile === 'false' && window.innerWidth < 750) return;

        const delay = (parseInt(this.dataset.delay, 10) || 5) * 1000;
        this.showTimeout = setTimeout(() => this.show(), delay);
      }

      disconnectedCallback() {
        if (this.showTimeout) clearTimeout(this.showTimeout);
      }

      show() {
        this.setAttribute('open', '');
        document.body.classList.add('overflow-hidden');
        trapFocus(this);

        // Mark as dismissed on show (prevents re-show after page reload mid-popup)
        if (!Shopify.designMode) {
          localStorage.setItem('newsletter-popup-dismissed', Date.now().toString());
        }
      }

      hide() {
        this.removeAttribute('open');
        document.body.classList.remove('overflow-hidden');
        removeTrapFocus();
      }

      bindEditorEvents() {
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.dataset.section) this.show();
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.dataset.section) this.hide();
        });
      }
    }
  );
}
